<!-- tinymc富文本 -->
<template>
  <div v-loading="UploadLoading" class="l_tinymc">
    <editor
      v-model="editorValue"
      :init="init"
      :disabled="disabled"
    >
    </editor>
    <UploadPanel
      :accept="uploadType == 'uploadImg' ? 'image/*' : 'video/*'"
      ref="uploadPanelRef"
      :FileList="files"
      uploadType="importProject"
      dir="learn/"
      :uploadFilesBtn="true"
      @showUrl="showUrl"
    />
  </div>
</template>
<script>
import { PostData ,PostDataBlob} from "@/api/fetchdata";
import { getStorage } from '@/service/auth.js';
import axios from 'axios';
import UploadPanel from "@/components/UploadPanel";
import { initOssClient, uploadBase } from '@/components/UploadPanel/aliOssUpload.js';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
import tinymce from "../../../static/tinymce";
import Editor from "@tinymce/tinymce-vue";
import '../../../static/tinymce/themes/silver'
import '../../../static/tinymce/themes/silver/theme'
import '../../../static/tinymce/icons/default'; //引入编辑器图标icon，不引入则不显示对应图标
//在TinyMce.vue中接着引入相关插件
import '../../../static/tinymce/skins/ui/oxide/skin.css'
import "../../../static/tinymce/icons/default/icons"
// import "../../../static/tinymce/plugins/image" // 插入上传图片插件
// import "../../../static/tinymce/plugins/media" // 插入视频插件
import "../../../static/tinymce/plugins/table" // 插入表格插件
import "../../../static/tinymce/plugins/lists" // 列表插件
import "../../../static/tinymce/plugins/wordcount" // 字数统计插件
// import "../../../static/tinymce/plugins/code" // 源码
import '../../../static/tinymce/plugins/codesample'  //代码示例
import "../../../static/tinymce/plugins/fullscreen" //全屏
import '../../../static/tinymce/plugins/advlist'  //高级列表
import '../../../static/tinymce/plugins/anchor'  //锚点
import '../../../static/tinymce/plugins/autolink'  //自动链接
import '../../../static/tinymce/plugins/autoresize'  //编辑器高度自适应,注：plugins里引入此插件时，Init里设置的height将失效
import '../../../static/tinymce/plugins/autosave'  //自动存稿
import '../../../static/tinymce/plugins/charmap'  //特殊字符
import '../../../static/tinymce/plugins/directionality'  //文字方向
import '../../../static/tinymce/plugins/emoticons'  //表情
import '../../../static/tinymce/plugins/help'  //帮助
import '../../../static/tinymce/plugins/importcss'  //引入css
import '../../../static/tinymce/plugins/insertdatetime'  //插入日期时间
import '../../../static/tinymce/plugins/link'  //超链接
import '../../../static/tinymce/plugins/nonbreaking' //插入不间断空格
import '../../../static/tinymce/plugins/pagebreak' //插入分页符
import '../../../static/tinymce/plugins/preview'//预览
import '../../../static/tinymce/plugins/quickbars'  //快速工具栏
import '../../../static/tinymce/plugins/save'  //保存
import '../../../static/tinymce/plugins/searchreplace'  //查找替换
import '../../../static/tinymce/plugins/table'  //表格
// import '../../../static/tinymce/plugins/template'  //内容模板
import '../../../static/tinymce/plugins/visualblocks'  //显示元素范围
import '../../../static/tinymce/plugins/visualchars'  //显示不可见字符
export default {
  name: "tinymce",
  components: {
    Editor,
    UploadPanel
  },
  props: {
    //传入一个value，使组件支持v-model绑定
    value: {
      type: String,
      default: "",
    },
    disabled: { // 是否禁止编辑
      type: Boolean,
      default: false,
    },
    plugins: {
      type: [String, Array],
      default:
        "table lists wordcount fullscreen advlist anchor autolink charmap directionality emoticons insertdatetime link nonbreaking pagebreak preview save searchreplace table visualblocks visualchars globalwrapper",
    },
    toolbar: { // 列表功能区展示，按顺序渲染
      type: [String, Array],
      default:
        // 'undo redo | searchreplace | bold  italic | underline | strikethrough | alignleft  aligncenter alignright | outdent indent  blockquote  removeformat subscript superscript code codesample hr bullist numlist link image charmap preview anchor pagebreak insertdatetime  table  forecolor backcolor'
        "codesample bold italic underline alignleft aligncenter alignright alignjustify | undo redo | formatselect | fontselect | fontsizeselect | forecolor backcolor | bullist numlist outdent indent | lists link table code | removeformat | uploadImage uploadMedia | fullscreen",
    },
  },
  data() {
    return {
      //初始化配置
      init: {
      //汉化编译
        language_url: "../../../static/tinymce/langs/zh_CN.js", // 语言包路径
        language: "zh_CN", // 语言
        skin_url: "../../../static/tinymce/skins/ui/oxide", // skin路径，
        emoticons_database_url: '../../../static/tinymce/plugins/emoticons/js/emojis.js', // 表情路径
        height: '100%', // 默认高度
        width: '100%', // 默认宽度
        branding: true, //是否禁用
        menubar: this.disabled ? false : true, //顶部菜单栏显示
        image_dimensions: false, //去除宽高属性
        promotion: false, // 隐藏右上角Upgrade 按钮
        font_formats: "微软雅黑='微软雅黑';宋体='宋体';黑体='黑体';仿宋='仿宋';楷体='楷体';隶书='隶书';幼圆='幼圆';Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings", //字体
        fontsize_formats: '11px 12px 14px 16px 18px 24px 36px 48px 64px 72px', //文字大小
        lineheight_val: "1 1.1 1.2 1.3 1.35 1.4 1.5 1.55 1.6 1.75 1.8 1.9 1.95 2 2.1 2.2 2.3 2.4 2.5 2.6 2.7 2.8 3 3.1 3.2 3.3 3.4 4 5", // 行高
        paste_data_images: false,  //图片是否可粘贴
        paste_webkit_styles: "all",  //此选项允许您指定在WebKit中粘贴时要保留的样式
        paste_merge_formats: true, //此选项启用粘贴插件的合并格式功能
        nonbreaking_force_tab: false, // 此选项允许您在用户按下键盘tab键时强制TinyMCE插入三个实体
        paste_auto_cleanup_on_paste: false,
        file_picker_types: 'file', // 此选项允许您通过空格或逗号分隔的类型名称列表指定所需的文件选取器类型。目前有三种有效类型：文件、图像和媒体
        content_css: '../../../static/tinymce/skins/content/default/content.css',
        imagetools_toolbar: 'editimage',  // 图片控制的工具栏
        content_style:"img {max-width:100%;height:auto}", // 图片最大宽度
        plugins: this.plugins, // 修改插件
        toolbar: this.toolbar, // 顶部导航栏
        images_upload_handler: this.upload,
        setup: (editor) => {
          let _this = this;
          _this.myEditor = editor
          //定义一个名为 assignment 的toolbar
          editor.ui.registry.addButton('uploadImage', {
            icon: "image",
            tooltip: '上传图片',
            onAction: () => {
              _this.uploadType = 'uploadImg';
              _this.$nextTick(() => {
                _this.$refs.uploadPanelRef.$refs.fileInputRef.click();
              });
            },
          });
          editor.ui.registry.addButton('uploadMedia', {
            icon: "upload",
            tooltip: '上传视频',
            onAction: () => {
              _this.uploadType = 'uploadVideo';
              _this.$nextTick(() => {
                _this.$refs.uploadPanelRef.$refs.fileInputRef.click();
              })
            },
          });
          editor.on('PostProcess', (e) => {
            // 在生成的内容后处理时执行
            e.content = '<div class="myTinymceWrapper">' + e.content + '</div>'; // 将生成的内容包裹在一个全局的div中
          });
        },
      },
      uploadType: 'uploadImg',
      UploadLoading: false,
      uid: getStorage('uid'),
      token: getStorage('token'),
      ossDomain: getStorage('oss_domain'),
      myEditor: null,
      files: [],
      client: {}
    };
  },
  mounted() {
    tinymce.init({});
  },
  computed: {
    editorValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", val);
      },
    },
  },
  methods: {
    async getVideoFirstFrame(videoUrl) {
      // 创建video元素
      const video = document.createElement('video');
      video.src = videoUrl;
      video.setAttribute('crossOrigin', 'Anonymous'); // 处理跨域
      video.setAttribute('preload', 'auto'); // auto|metadata|none

      return new Promise((resolve, reject) => {
        video.addEventListener('loadeddata', async () => {
          // 等待视频数据加载完成后绘制第一帧
          if (video.videoWidth > 0 && video.videoHeight > 0) {
            // 创建canvas元素
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            // 将视频第一帧绘制到canvas上
            const ctx = canvas.getContext('2d');
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height); // 注意这里的起始点是 (0, 0)
            // 将canvas图像转换为base64格式的数据URI
            const dataUrl = canvas.toDataURL();
            // 将Base64数据转换为Blob对象
            const blob = await fetch(dataUrl).then(res => res.blob());
            // 将 base64 数据上传到 OSS 并返回地址
            let ossUrl = await uploadBase(this.client, blob, 'learn/');
            resolve(ossUrl);
          } else {
            reject(`Failed to get video dimensions.`);
          }
        });

        // 如果视频加载出错，则返回错误信息
        video.addEventListener('error', () => {
          reject(`Failed to load video: ${videoUrl}`);
        });
      });
    },
    showUrl(url,files,client){
      this.client = client;
      if(this.uploadType == 'uploadImg'){
        this.myEditor.execCommand('insertImage', false, `${this.ossDomain+'learn/'+url}`, );
      } else {
        this.getVideoFirstFrame(`${this.ossDomain+'learn/'+url}`)
        .then((dataUrl) => {
          let videoHtml = `<p><span class="mce-preview-object mce-object-video" contenteditable="false"data-mce-object="video" data-mce-p-allowfullscreen="allowfullscreen"data-mce-p-frameborder="no" data-mce-p-scrolling="no"data-mce-p-src="${this.ossDomain+'learn/'+url}" ><video src="${this.ossDomain+'learn/'+url}" width="420"style="width:auto;max-width:100%;height:auto;background-image:url(${dataUrl});background-size: cover;background-position: center;background-repeat: no-repeat;"controls="controls"></video></span></p>`;
          this.myEditor.execCommand('mceInsertContent', false, videoHtml);
        })
        .catch((error) => {
          let videoHtml = `<p><span class="mce-preview-object mce-object-video" contenteditable="false"data-mce-object="video" data-mce-p-allowfullscreen="allowfullscreen"data-mce-p-frameborder="no" data-mce-p-scrolling="no"data-mce-p-src="${this.ossDomain+'learn/'+url}" ><video src="${this.ossDomain+'learn/'+url}" width="420"style="width:auto;max-width:100%;height:auto;background-color:#000;"controls="controls"></video></span></p>`;
          this.myEditor.execCommand('mceInsertContent', false, videoHtml);
        });
      }
    },
    //添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
    //需要什么事件可以自己增加
    // onClick(e) {
    //   console.log('++++++++++666')
    //   this.$emit("onClick", e, tinymce);
    // },
    // clear() {
    //   this.myValue = "";
    // },
  },
};
</script>
<style scoped>
.l_tinymc{
  width: 100%;
  height: 100%;
}
.tox-tinymce-aux {
  z-index: 9999 !important;
}
</style>




// WEBPACK FOOTER //
// src/components/Tinymce/Tinymce.vue